import { useSecWorker, useSecWorkerState } from '@/hooks/useSecWorker';
import { createContext } from 'react';

export const SecordWorkerContext = createContext({} as useSecWorkerState);
const { Provider } = SecordWorkerContext;
type WorkerContextProps = {
    children: JSX.Element | Array<JSX.Element>;
};
export const SecordWorkerProvider = ({ children }: WorkerContextProps) => {
    const sw = useSecWorker();
    return <Provider value={sw}>{children}</Provider>;
};
